import { render, staticRenderFns } from "./FullScreenModalHeader.vue?vue&type=template&id=c82edb0c&scoped=true"
import script from "./FullScreenModalHeader.vue?vue&type=script&lang=js"
export * from "./FullScreenModalHeader.vue?vue&type=script&lang=js"
import style0 from "./FullScreenModalHeader.vue?vue&type=style&index=0&id=c82edb0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82edb0c",
  null
  
)

export default component.exports